import { render } from "./CardChallengeLeaderboardFirst.vue?vue&type=template&id=ced05c98&scoped=true"
import script from "./CardChallengeLeaderboardFirst.vue?vue&type=script&lang=js"
export * from "./CardChallengeLeaderboardFirst.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-leaderboard-first.css?vue&type=style&index=0&id=ced05c98&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced05c98"]])

export default __exports__